const OPEN_WEATHER_LANGUAGE_ALIASES: Record<string, string> = {
  'zh-cn': 'zh_cn',
  'zh-tw': 'zh_tw',
  'pt-br': 'pt_br',
  cs: 'cz',
  ko: 'kr',
  lv: 'la'
};

export const getOpenWeatherLanguage = (locale?: string) => {
  if (!locale) {
    return;
  }

  const normalized = locale.toLowerCase();
  if (OPEN_WEATHER_LANGUAGE_ALIASES[normalized]) {
    return OPEN_WEATHER_LANGUAGE_ALIASES[normalized];
  }

  const [baseLanguage] = normalized.split('-');

  return baseLanguage;
};
